import React, { useState, useEffect } from 'react';
import Bottombar from '../common/bottombar';
import { FaEdit, FaPencilAlt } from 'react-icons/fa';
import { ALL_COUNTRIES, LOGIN, UPDATEAVTAR, UPDATEUSER } from '../helpers/Constant';
import { FiArrowUpRight } from 'react-icons/fi';
import { Line } from "react-chartjs-2";
import { IoIosArrowForward, IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { BiInfoCircle } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { getUserType, setSession, getUserInfo, checkAuth } from '../utils/common';
import { GET_DAILY_BMI_DATA, GET_DAILY_REPORT_DATA, BMICALCULATOR, GETLEVELREPORT, GET_USER_ACCOUNT_HISTORIES, DETAILED } from '../helpers/Constant';
import { postDataWithToken, updateData, getDataWithToken } from '../api/api';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import BackButton from '../common/backButton';

function Profile() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userType = getUserType();
    const AVTAR_IMAGE_URL = `${process.env.REACT_APP_BASE_PATH}/admin/public/avtar/`;
    const [formErrors, setFormErrors] = useState({});
    const [allCountries, setAllCountries] = useState(Object.values(ALL_COUNTRIES));
    const [selectedImage, setSelectedImage] = useState(null);
    const [localImagePreviewUrl, setLocalImagePreviewUrl] = useState('');
    const [localPreviewFailed, setLocalPreviewFailed] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState({});
    const [userBmiPreviousData, setUserBmiPreviousData] = useState({});
    const [targetAverage, setTargetAverage] = useState([]);
    const [levels, setLevels] = useState([]);
    const [winningAmount, setWinningAmount] = useState(0);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showLevelInfoModal, setShowLevelInfoModal] = useState(false);
    const [physicalActivity, setPhysicalActivity] = useState(0);
    const [physicalActivityTimeFormat, setPhysicalActivityTimeFormat] = useState('min');
    const [selectedLocation, setSelectedLocation] = useState();
    const [activityIcon, setActivityIcon] = useState(false);
    const year = moment().format('YYYY');
    const currentMonth = moment().format('M');
    const currentDate = moment().format('D');
    const currentYear = moment().format('YYYY');
    const currentMonthNumber = moment().format('M');
    const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    useEffect(() => {
        const user = getUserInfo();
        setUserData(user);
        async function fetchData() {
            if (user) {
                const location = (user && user.address1) ? user.address1 : '';
                setSelectedLocation(location);

                const levelNames = ["Copper", "Bronze", "Silver", "Gold", "Platinum"];
                const levelMapping = {};
                levelNames.forEach((level, index) => {
                    levelMapping[level] = index + 1;
                });

                const limit = { limit: 0 };
                const userAccounts = await postDataWithToken(GET_USER_ACCOUNT_HISTORIES, limit);
                if (userAccounts.status == 200) {
                    const data = userAccounts['data'];
                    if (data.length > 0) {
                        setWinningAmount(data[0]['winningAmount']);
                    }
                }

                const activityData = await postDataWithToken(GET_DAILY_BMI_DATA);

                if (activityData.data && activityData.data.length > 0) {
                    var activityArr = [];
                    for (let i = 1; i <= currentDate; i++) {
                        let physicalActivity = 0;
                        activityData.data.forEach((data) => {
                            const date = moment(data.createdAt).format('MM-DD-YYYY');
                            var dateOfCurrent = moment({ year: currentYear, month: (currentMonthNumber - 1), day: i }).format('MM-DD-YYYY');
                            const isCurrentMonthAndYear = moment(date).isSame(dateOfCurrent);
                            if (isCurrentMonthAndYear) {
                                physicalActivity += data.physicalActivity;
                            }
                        });
                        activityArr.push(Math.round(physicalActivity / 60));
                    }
                    setPhysicalActivity(activityArr);
                   
                    const totalActivity = activityArr.reduce((acc, val) => acc + val, 0);
                    const avgMins = activityArr.length > 0 ? totalActivity / activityArr.length : 0;

                    let activityValue = 0;
                    let activityUnit = '';

                    if (avgMins >= 60) {
                        activityValue = (avgMins / 60).toFixed(1);
                        activityUnit = 'hr';
                    } else {
                        activityValue = Math.round(avgMins);
                        activityUnit = 'min';
                        if(avgMins < 30) setActivityIcon(true);
                    }

                    setPhysicalActivity(activityValue);      
                    setPhysicalActivityTimeFormat(activityUnit);
                }

                const dailyTargetData = await getDataWithToken(GET_DAILY_REPORT_DATA);
                if (dailyTargetData.length > 0) {
                    const averageTarget = [];
                    for (let monthIndex = 0; monthIndex < currentMonth; monthIndex++) {
                        let sumOfTarget = 0;
                        let targetSum = 0;
                        const firstDateOfMonth = moment({ year: year, month: monthIndex }).format('MM-DD-YYYY');

                        // Avoid defining callbacks inside a loop (eslint no-loop-func).
                        for (const row of dailyTargetData) {
                            const date = moment(row.createdAt).format('MM-DD-YYYY');
                            const isCurrentMonthAndYear =
                                moment(date).isSame(firstDateOfMonth, 'month') &&
                                moment(date).isSame(firstDateOfMonth, 'year');
                            if (isCurrentMonthAndYear) {
                                sumOfTarget += Number(row.target || 0);
                                targetSum += 1;
                            }
                        }

                        if (
                            parseInt(monthIndex + 1) === parseInt(currentMonthNumber) &&
                            sumOfTarget === 0 &&
                            targetSum === 0 &&
                            userData &&
                            userData.dailyTarget > 0
                        ) {
                            sumOfTarget = Number(userData.dailyTarget);
                            targetSum = 1;
                        }

                        const average = targetSum === 0 ? 0 : (sumOfTarget / targetSum).toFixed(2);
                        averageTarget.push(average);
                    }
                    if(dailyTargetData[dailyTargetData.length - 1]) {
                        setUserBmiPreviousData(dailyTargetData[dailyTargetData.length - 2]);
                    }
                    setTargetAverage(averageTarget);
                }

                setLoading(false);
            } else {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        setLocalPreviewFailed(false);
        if (!selectedImage) {
            setLocalImagePreviewUrl('');
            return;
        }
        const url = URL.createObjectURL(selectedImage);
        setLocalImagePreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [selectedImage]);

    const openEditModal = () => {
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
    };

    const openLevelInfoModal = () => {
        setShowLevelInfoModal(true);
    };

    const closeLevelInfoModal = () => {
        setShowLevelInfoModal(false);
    };

    const handleNavigation = () => {
        navigate(`/${DETAILED}`);
    }

    const handleGuestLogin = () => {
        setSession();
        navigate(`/${LOGIN}`);
    }

    const handleProfileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setSelectedImage(file);
        e.target.value = '';
    }

    const handleUpdateProfileForm = async (e) => {
        e.preventDefault();
        const fnameRef = document.getElementById("fname");
        const lnameRef = document.getElementById("lname");
        const locationRef = document.getElementById("location");

        const formFields = [
            { ref: fnameRef, name: fnameRef.name, errorMsgName: "First name" },
            { ref: lnameRef, name: lnameRef.name, errorMsgName: "Last name" },
            { ref: locationRef, name: locationRef.name, errorMsgName: "Location" },
        ];

        const errors = {};

        formFields.forEach((field) => {
            if (field.ref.value === "" || field.ref.value === null) {
                errors[field.name] = `${field.errorMsgName} is required.`;
            }
        });

        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            setLoading(true);

            var userId = userData._id;

            if (selectedImage) {
                const avtarData = new FormData();
                avtarData.append('avtar', selectedImage);

                await postDataWithToken(UPDATEAVTAR + userId, avtarData);
            }
            let data = {
                "user": userId,
                "fname": fnameRef.value,
                "lname": lnameRef.value,
                "address1": locationRef.value
            }
            const response = await updateData(UPDATEUSER, data);
            if (response.status === 200) {
                setFormErrors({});
                const userInfo = await checkAuth();
                setUserData(userInfo);
                setLoading(false);
                closeEditModal();
            } else {
                setLoading(false);
            }
        }
    }

    const handleCalibrateTarget = () => {
        navigate(`/${BMICALCULATOR}`);
    }

    const handleLocationChange = (event) => {
        setSelectedLocation(event.target.value);
    };

    const bmiData = {
        labels: labels,
        datasets: [
            {
                data: targetAverage,
            },
        ],
    };

    const levelData = {
        labels: labels,
        datasets: [
            {
                data: levels,
            },
        ],
    };
    return (
        <div className='wrapper h-100'>
            {loading ?
                <div className="loader">
                    <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
                </div>
                : ""}
            {userType === 'guest_user' &&
                <div className='guest_login_cta d-flex align-items-center justify-content-center h-100'>
                    <button className='mx-3 mb-5 mt-0 fw-bold text-secondary bg-warning' type='button' onClick={handleGuestLogin}>{t('Login / Sign Up')}</button>
                </div>}
            {userType === 'real_user' &&
                <>
                    {showEditModal || showLevelInfoModal ? (
                        <BackButton
                            label={t('Profile')}
                            className="position-absolute"
                            closeFunction={showEditModal ? closeEditModal : closeLevelInfoModal}
                        />
                    ) : null}
                    <div className='profile_screen_wrapper'>
                        <div className='profile_section rounded-corners d-flex flex-column justify-content-center align-items-center position-relative bg-secondary'>
                            {userData && userData.avtar ?
                                <div className='rounded-circle profile_image home_profile_img border border-white d-flex justify-content-center align-items-center avtar_alternate overflow-hidden'>
                                    <img src={AVTAR_IMAGE_URL + userData._id + "/" + userData.avtar} alt='Profile' className='img-fluid' />
                                </div>
                                :
                                <div className='rounded-circle profile_image home_profile_img border border-white d-flex justify-content-center align-items-center avtar_alternate'>
                                    {userData.fname && userData.lname && (
                                        <h3 className='mb-0 text-white fw-bold text-uppercase'>{userData.fname[0]}{userData.lname[0]}</h3>
                                    )}
                                </div>
                            }
                            <h5 className='mb-0 p-2 fw-bold text-capitalize text-center text-break'>{userData != null ? userData.fname + ' ' + userData.lname : ''}</h5>
                            <h6 className="mb-2 px-2 text-light text-center">{userData != null ? t(userData.address1) : ''}</h6>
                            <button className='edit-btn position-absolute text-light end-0 border-0 rounded-circle top-0 mt-2 me-2 text-center' onClick={openEditModal} ><FaEdit className='mb-1' size={16} /></button>
                        </div>
                        <div className='bmi_profile d-flex justify-content-center align-items-stretch text-white position-relative bg-secondary w-100 p-2 pt-4 rounded-corners mt-3'>
                            <div className='step-1 w-xs-50 text-center w-25 px-1 border-end d-flex justify-content-between flex-column'>
                                <h6 className='mb-0 mt-1 text-light'>{t('BMI')}</h6>
                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                    <h5 className='my-2 fw-bold'>{userData.bmi}</h5>
                                    {(userBmiPreviousData && userData.bmi > userBmiPreviousData.bmi) || (!userBmiPreviousData && userData.bmi >= 25) ? <IoIosArrowDown size={14} color='F55A68' /> : <IoIosArrowUp size={14} className='text-success' />}
                                </div>
                            </div>
                            <div className='step-2 w-xs-50 text-center w-25 px-1 border-end border-start d-flex justify-content-between flex-column'>
                                <h6 className='mb-0 mt-1 text-light'>{t('Current Month Target')}</h6>
                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                    <h5 className='my-2 fw-bold'>{userData.dailyTarget}</h5>
                                </div>
                            </div>
                            <div className='step-3 w-xs-50 text-center w-25 px-1 d-flex justify-content-between flex-column'>
                                <h6 className='mb-0 mt-1 text-light'>{t('Avg Activity time')}</h6>
                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                    <h5 className='my-2 fw-bold'>{physicalActivity}<span className='ms-1 text-light'>{physicalActivityTimeFormat}</span></h5>
                                    {(activityIcon === true) ? <IoIosArrowDown size={14} color='F55A68'/> : <IoIosArrowUp size={14} className='text-success' />}
                                </div>
                            </div>
                            <button className='position-absolute top-0 end-0 border-0 bg-transparent text-light'><FiArrowUpRight size={20} className='edit-icon' onClick={handleNavigation} /></button>
                        </div>
                        <div className='profile_content_wrapper your_daily_target position-relative bg-secondary rounded-corners p-12 mt-3'>
                            <div className='d-flex align-items-start justify-content-between gap-3'>
                                <div className='mb-3'>
                                    <h5 className='mb-1 text-white fw-bold opacity-75'>{t('Your Daily Target')}</h5>
                                    <h6 className='text-white opacity-75 px-2 mb-0'>{year}</h6>
                                </div>
                                <span className='m-0 text-warning fw-bold text_shadow_green d-flex align-items-center'><img src='../images/fireicon.svg' height={25} alt='fireicon' className='me-1'></img>{(Math.round(userData.dailyTarget)).toFixed(0)}</span>
                            </div>
                            <Line data={bmiData} options={{
                                plugins: {
                                    legend: {
                                        display: false,
                                    },
                                    tooltips: {
                                        enabled: false,
                                    },
                                },
                                elements: {
                                    point: {
                                        radius: 4,
                                        backgroundColor: '#daff00'
                                    },
                                    line: {
                                        backgroundColor: "black",
                                        borderColor: "#daff00",
                                        borderWidth: 2
                                    }
                                },
                                clip: false,
                                scales: {
                                    y: {
                                        border: {
                                            width: 1,
                                            color: '#daff00',
                                        },
                                        grid: {
                                            drawBorder: false,
                                            display: false,
                                        },
                                        ticks: {
                                            color: '#fff'
                                        },
                                        min: 1,
                                    },
                                    x: {
                                        border: {
                                            width: 1,
                                            color: '#daff00',
                                        },
                                        ticks: {
                                            color: (label, index) => {
                                                return (currentMonth > label.index) ? '#fff' : '#707070';
                                            },
                                        },
                                    }
                                },
                            }} />
                            <button type='button' className='d-block position-relative w-100 text-center mt-2 go_button text-white border-0 px-4' disabled={(userData.isTrialComplete) ? true : false} onClick={handleCalibrateTarget} >{t('Calibrate Daily Target')}<IoIosArrowForward color="white" size={22} className='arrow-icon position-absolute' /></button>
                        </div>
                        {/* <div className='profile_content_wrapper level_progression position-relative bg-secondary rounded-corners p-12 mt-3'>
                            <div className='d-flex align-items-center mb-2'>
                                <h5 className='mb-0 text-white fw-bold opacity-75 text-nowrap'>{t('League Progression')}
                                    <BiInfoCircle className='text-light ms-2' onClick={openLevelInfoModal} />
                                </h5>
                                <img src={userData != null && userData.levelData ?
                                    (userData.levelData.current === 'Copper' ? '../images/copperbadge.png' :
                                        userData.levelData.current === 'Bronze' ? '../images/bronzebadge.png' :
                                            userData.levelData.current === 'Silver' ? '../images/silverbadge.png' :
                                                userData.levelData.current === 'Gold' ? '../images/goldbadge.png' :
                                                    '../images/platinumbadge.png') : '../images/platinumbadge.png'
                                } alt='Reward user' className='rounded-circle home_profile_img position-absolute profile_img mt-2' />
                            </div>
                            <h6 className='text-white opacity-75 mb-3 px-2'>{year}</h6>
                            <Line data={levelData} options={{
                                plugins: {
                                    legend: {
                                        display: false,
                                    },
                                    tooltips: {
                                        enabled: false,
                                    },
                                },
                                elements: {
                                    point: {
                                        radius: 4,
                                        backgroundColor: '#daff00'
                                    },
                                    line: {
                                        backgroundColor: "black",
                                        borderColor: "#daff00",
                                        borderWidth: 1
                                    }
                                },
                                clip: false,
                                scales: {
                                    y: {
                                        border: {
                                            width: 1,
                                            color: '#daff00',
                                        },
                                        min: 1,
                                        max: 5,
                                        ticks: {
                                            stepSize: 1,
                                            callback: function (value) {
                                                return `Leg 0${value}`
                                            },
                                            color: '#fff'
                                        },
                                    },
                                    x: {
                                        border: {
                                            width: 1,
                                            color: '#daff00',
                                        },
                                        ticks: {
                                            color: (label, index) => {
                                                return (currentMonth > label.index) ? '#fff' : '#707070';
                                            },
                                        },
                                    }
                                }
                            }} />
                        </div> */}
                    </div>
                    <div className={`modal ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content modal_content edit_profile_modal text-center bg-secondary p-3">
                                <div className="modal-body p-0">
                                    <h4 className='fw-bold mb-4 text-white'>{t('Edit Profile')}</h4>
                                    <form className='mt-4' onSubmit={handleUpdateProfileForm}>
                                        <div className='form_field position-relative profile_image_label my-4'>
                                            <label htmlFor='profileImage' style={{ cursor: 'pointer' }}>
                                                <div className='position-relative d-inline-block'>
                                                    {(userData && userData.avtar) || selectedImage ?

                                                        (selectedImage && localImagePreviewUrl && !localPreviewFailed ? (
                                                        <img
                                                            className="profile_image"
                                                            src={localImagePreviewUrl}
                                                            width={110}
                                                            height={110}
                                                            alt="Profile"
                                                            onError={() => setLocalPreviewFailed(true)}
                                                        />
                                                        ) : (!selectedImage && userData && userData.avtar ? (
                                                        <img
                                                            className="profile_image"
                                                            src={AVTAR_IMAGE_URL + userData._id + "/" + userData.avtar}
                                                            width={110}
                                                            height={110}
                                                            alt="Profile"
                                                        />
                                                        ) : (
                                                        <div className='rounded-circle home_profile_img border border-white d-flex justify-content-center align-items-center avtar_alternate' style={{ width: 110, height: 110 }}>
                                                            {userData && userData.fname && userData.lname && (
                                                                <h5 className='mb-0 text-white fw-bold text-uppercase'>
                                                                    {userData.fname[0] + userData.lname[0]}
                                                                </h5>
                                                            )}
                                                        </div>
                                                        )))
                                                        :
                                                        <div className='rounded-circle  home_profile_img border border-white d-flex justify-content-center align-items-center avtar_alternate'>
                                                            {userData && userData.fname && userData.lname && (
                                                                <h5 className='mb-0 text-white fw-bold text-uppercase'>
                                                                    {userData.fname[0] + userData.lname[0]}
                                                                </h5>
                                                            )}
                                                        </div>
                                                    }
                                                    <div className='position-absolute bottom-0 end-0 bg-warning rounded-circle d-flex align-items-center justify-content-center' style={{ width: '32px', height: '32px', border: '2px solid white' }}>
                                                        <FaPencilAlt className='text-dark' size={14} />
                                                    </div>
                                                </div>
                                                <input
                                                    name='profileImage'
                                                    type="file"
                                                    id='profileImage'
                                                    className='d-none'
                                                    accept="image/jpeg,image/jpg,image/png,image/heic,image/webp,.jpg,.jpeg,.png,.heic,.webp"
                                                    onChange={handleProfileChange}
                                                />
                                                <p className='field_error'>{formErrors['profileImage']}</p>
                                            </label>
                                        </div>
                                        <div className='profile_form'>
                                            <div className='form_field position-relative mb-4'>
                                                <input type="text" className='w-100 ps-3' id="fname" name="fname" defaultValue={(userData && userData.fname) ? userData.fname : ''} placeholder='First name' />
                                                <p className='field_error text-start'>{formErrors['fname']}</p>
                                            </div>
                                            <div className='form_field position-relative mb-4'>
                                                <input type="text" className='w-100 ps-3' id="lname" name="lname" defaultValue={(userData && userData.lname) ? userData.lname : ''} placeholder='Last name' />
                                                <p className='field_error text-start'>{formErrors['lname']}</p>
                                            </div>
                                            <div className='form_field position-relative mb-4'>
                                                <select className="form-select form_select w-100 ps-3" id="location" name="location" value={selectedLocation} onChange={handleLocationChange}>
                                                    <option value="" disabled>{t('SelectLocation')}</option>
                                                    {allCountries.map((country) => (
                                                        <option value={country}>{t(country)}</option>
                                                    ))}
                                                </select>
                                                <p className='field_error text-start'>{formErrors['location']}</p>
                                            </div>
                                            <button type="submit" className='cta_button bg-warning text-dark' disabled={loading}>{t('Submit')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`modal ${showLevelInfoModal ? 'show' : ''}`} style={{ display: showLevelInfoModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content modal_content info_modal bg-secondary p-3 pb-4">
                                <div className="modal-body p-0">
                                    <h4 className='fw-bold mb-2 text-white text-center'>{t('How levels work?')}</h4>
                                    <p className='text-light mb-0'>The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {(showLevelInfoModal || showEditModal) && <div className="modal-backdrop show"></div>}
                </>}
            <Bottombar />
        </div>
    )
}

export default Profile